import loadable from '@loadable/component';

export const SubscribedToSubsiteModalLoadable = loadable(
  () => import('./SubscribedToSubsiteModal'),
  { resolveComponent: (module) => module.SubscribedToSubsiteModal },
);
